import * as actionTypes from 'src/actions';

const initialState = {
    loading: false,
    vendor: null
};

const vendorReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SESSION_VENDOR_REQUEST:
            return { loading: true };
        case actionTypes.SESSION_VENDOR_SUCCESS: {
            return {
                loading: false,
                vendor: action.payload
            };
        }
        case actionTypes.SESSION_VENDOR_FAIL:
            return {
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
};

export default vendorReducer;
